module.exports = __webpack_public_path__ + "media/images/official/top_about3-a8cfd297993b572a64b4a0c7f894c45e.webp";